module.exports = __webpack_public_path__ + "media/images/writer/monitor/sp-mv-imgline@3x-707e2001cb37565c3fe229c5eb87495f.png";